import { isNullOrWhiteSpace } from 'owa-string-utils';
import type LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import { createLocationPersonaFromStringLocation } from 'owa-location-persona';
import { addLocationsFromCommonWell } from 'owa-calendar-compose-form-actions';

export default function resolveStringLocation(unresolvedLocation: string) {
    if (!isNullOrWhiteSpace(unresolvedLocation)) {
        const newSelectedItem: LocationCommonWellItemViewState = {
            persona: createLocationPersonaFromStringLocation(unresolvedLocation),
            displayText: unresolvedLocation,
            isValid: true,
            isSelected: false,
            isContextMenuOpen: false,
        };
        addLocationsFromCommonWell([newSelectedItem]);
    }
}
